<label #labelWrapper class="form-field" [class.with-label]="label" [class.form-field-entered]="hasValue()">
  <ng-content select="textarea"></ng-content>

  @if (label) {
    <span class="form-field-label" [class.form-field-label_shrinked]="hasValue()">
      {{ label }}
    </span>
  }

  <div class="form-field-right-side">
    <ng-content select="icon"></ng-content>
  </div>

  <span class="form-field-comment">{{ error || comment }}</span>
</label>
